var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrainHumidity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2762 23.8488C33.8541 17.8468 41.8383 13.5988 50.4914 11.4972C59.1446 9.39563 68.1877 9.50812 76.7859 11.8243C85.3841 14.1405 93.2601 18.5858 99.6866 24.7496C106.113 30.9135 110.883 38.5972 113.556 47.0912C116.229 55.5853 116.719 64.6159 114.98 73.3492C113.241 82.0825 109.33 90.2369 103.607 97.0594C97.8849 103.882 90.5357 109.153 82.2384 112.385C73.9411 115.617 64.9631 116.707 56.1334 115.553",
    stroke: "#999898",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.477 25.5233C110.075 35.1214 115.624 48.0362 115.982 61.6053C116.339 75.1743 111.476 88.3632 102.397 98.453C93.3167 108.543 80.7118 114.764 67.1803 115.835C53.6489 116.905 40.2224 112.744 29.6689 104.207",
    stroke: "#999898",
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1979 105.845C83.225 113.835 69.6047 117.31 56.145 115.555C42.6853 113.799 30.4121 106.946 21.8558 96.409C13.2995 85.8716 9.11228 72.453 10.1573 58.9196C11.2023 45.3861 17.4 32.7695 27.4726 23.6706",
    stroke: "#999898",
    strokeWidth: 20
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrainHumidity);
export default __webpack_public_path__ + "static/media/grain-humidity.548d9870.svg";
export { ForwardRef as ReactComponent };